<template>
    <q-dialog v-model="showModal" persistent>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-card-section>
                <slot name="header">
                    <div class="text-h6"><q-icon :name="icon" color="orange" size="20px"/> {{title}}</div>
                </slot>
            </q-card-section>

            <q-separator/>

            <q-card-section>
                <q-inner-loading style="z-index: 999" :showing="loading">
                    <q-spinner-dots size="100px" color="primary"/>
                </q-inner-loading>
                <bulk-email-form :recipients="recipients" v-model="emailObj" />
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="cancelBtnLabel" color="primary" v-close-popup/>
                <q-btn :label="okBtnLabel" color="primary" @click="send" :loading="loading"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import Email from "../models/Email"
import BulkEmailForm from "./BulkEmailForm";

export default {
    name: "BulkEmailModal",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Notify user'
        },
        icon: {
            type: String,
            default: 'fa fa-exclamation-triangle'
        },
        okBtnLabel: {
            type: String,
            default: 'Send'
        },
        cancelBtnLabel: {
            type: String,
            default: 'Close'
        },
        recipients: {
            type: Array,
            default: ()=>([])
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data: function () {
        return {
            loading: false,
            emailObj: this.initialize()
        }
    },
    methods: {
        initialize() {
            return new Email({
                recipients: this.recipients.filter(recipient => recipient.email).map(recipient => recipient.id),
                subject: '',
                body: '',
                template: '',
                category: 'compulsory'
            })
        },
        send() {
            this.loading = true
            this.emailObj.sendBulkEmail((message) => {
                this.loading = false
                this.showModal = false
                this.$q.notify({
                    message: message,
                    color: 'positive',
                    icon: 'fa fa-check'
                });
            }).catch(error => {
                this.loading = false
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                });
            })
        }
    },
    created() {},
    mounted() {},
    watch: {
        showModal(val) {
            this.emailObj = this.initialize()
        }
    },
    components: {
        BulkEmailForm
    },
}
</script>
<style>

</style>
